import { lovetTheme } from '@aspendental/themes';

import { TAGBrand } from '@shared-components/types';

export function resolveBrandThemeConfig(_branding: TAGBrand) {
	return lovetTheme;
}
